import { Navigation } from "../components/shared/Brand";
import { Footer } from "../components/home/Footer";
import SEO from "../components/shared/SEO";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

// Full list of LinkedIn articles - ordered by publish date (newest first)
const allArticles = [
  {
    title: "What Skillful Cold Calling Should Teach Us About Hiring Sales Talent",
    description: "The traits required for successful cold calling—curiosity, listening, adaptability—are the same qualities to prioritize when hiring SDRs.",
    tag: "Talent",
    link: "https://www.linkedin.com/pulse/what-skillful-cold-calling-should-teach-us-hiring-sales-dan-leitner-cjgne/",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_efficiency-boost-10/artifacts/28a36716d3f21e22_Screenshot%202026-10-07%20at%204.23.15%E2%80%AFPM.png",
    isNew: true
  },
  {
    title: "The 5 Biggest Mistakes Sales Leaders Make When Building an SDR Team",
    description: "Five leadership mistakes including overvaluing experience, scaling too early, and blaming reps before auditing the system.",
    tag: "Leadership",
    link: "https://www.linkedin.com/pulse/5-biggest-mistakes-sales-leaders-make-when-building-sdr-dan-leitner-y1xse/",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_efficiency-boost-10/artifacts/9d62d125df5bf411_Screenshot%202026-10-07%20at%204.23.05%E2%80%AFPM.png",
    isNew: true
  },
  {
    title: "The Anatomy of Top Tier SDR Talent",
    description: "The six core traits that define high-potential SDRs: curiosity, coachability, resilience, ownership, adaptability, and trust-building.",
    tag: "Talent",
    link: "https://www.linkedin.com/pulse/anatomy-top-tier-sdr-talent-dan-leitner-5eqje/",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_efficiency-boost-10/artifacts/qn4uxax1_image.png",
    isNew: false
  },
  {
    title: "Betting on Talent: What to Look for in Your Next GTM Hire",
    description: "Hire for business impact, learning speed, and system building ability, not just experience on paper.",
    tag: "Talent",
    link: "https://www.linkedin.com/pulse/betting-talent-what-look-your-next-gtm-hire-dan-leitner-3tggc/",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_efficiency-boost-10/artifacts/a60buryb_Screenshot%202026-07-30%20at%2011.08.43%E2%80%AFAM.png",
    isNew: false
  },
  {
    title: "The Power of the Pause",
    description: "Why restraint—not just urgency—separates top performers in sales and leadership.",
    tag: "Leadership",
    link: "https://www.linkedin.com/pulse/power-pause-dan-leitner-jxrkf/",
    image: "https://media.licdn.com/dms/image/v2/D4D12AQFnpfLlPUaRzA/article-cover_image-shrink_720_1280/B4DZ9HnjqZJsAU-/0/1783612983984?e=2147483647&v=beta&t=6ydH3agA6q7tsG2-Nz8MQa3AwwVuK70m5Lu4lvQVBjc",
    isNew: false
  },
  {
    title: "The Great Democratization of Creation",
    description: "What happens when AI gives millions access to capabilities once reserved for the few?",
    tag: "AI",
    link: "https://www.linkedin.com/pulse/great-democratization-creation-dan-leitner-zdwde/",
    image: "https://media.licdn.com/dms/image/v2/D4E12AQFOo9ktGOzApA/article-cover_image-shrink_720_1280/B4EZ7F8eI1IwAU-/0/1781437429676?e=2147483647&v=beta&t=n1ltiHK33k6746HRL6g8umwBXobNRWmQRXWxMGvHuto"
  },
  {
    title: "The Three-Phase SDR System for Trade Show Pipeline",
    description: "Why trade show success comes down to execution across three phases: pre-show, live event, and post-show follow-up.",
    tag: "Events",
    link: "https://www.linkedin.com/pulse/three-phase-sdr-system-trade-show-pipeline-dan-leitner-2aiyc/",
    image: "https://media.licdn.com/dms/image/v2/D5612AQFqXi-X2TEUEQ/article-cover_image-shrink_720_1280/B56Z3yF9tlKIAI-/0/1777883152570?e=2147483647&v=beta&t=By-v9NqYXrnutFmb_H48dQdtoUlxDBzOLCJO8Bi_Sww"
  },
  {
    title: "Outbound Didn't Die. Leadership Left the Floor.",
    description: "The market didn't reject outbound. It rejected low effort outreach at scale. Leadership sets the standard.",
    tag: "Leadership",
    link: "https://www.linkedin.com/pulse/outbound-didnt-die-leadership-left-floor-dan-leitner-cfg1c/",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_efficiency-boost-10/artifacts/nfd0u0zd_Screenshot%202026-07-30%20at%2011.53.14%E2%80%AFAM.png"
  },
  {
    title: "The LRS AI SDR Agent Training Playbook",
    description: "How to build sales agents that actually work in production. A practical guide to training AI SDR agents.",
    tag: "AI + SDR",
    link: "https://www.linkedin.com/pulse/lrs-ai-sdr-agent-training-playbook-dan-leitner-0zmwc/",
    image: "https://media.licdn.com/dms/image/v2/D5612AQHCPjDgc_XE_A/article-cover_image-shrink_720_1280/B56Z1ht6VsJ0AI-/0/1775460924383?e=2147483647&v=beta&t=3fFKvz5y3kul8snZrWf8WppC7xzxN16T3rskVZaXrWk"
  },
  {
    title: "Where Do Future Top Performers Come From?",
    description: "Entry-level roles shape the next generation of closers.",
    tag: "Talent",
    link: "https://www.linkedin.com/pulse/ai-replaces-entry-level-roles-where-do-future-top-come-dan-leitner-1bfpc/",
    image: "https://media.licdn.com/dms/image/v2/D5612AQEOUEr3u3twSg/article-cover_image-shrink_720_1280/B56Z0A6bYwJ8AI-/0/1773836815134?e=2147483647&v=beta&t=eXM_aLqjof7nY6t01H10xJ81Fm_5KPRHxvd2exMBLL0"
  },
  {
    title: "The Talent System Behind Hyper-Growth",
    description: "Convert entry-level cohorts into revenue leaders.",
    tag: "Talent",
    link: "https://www.linkedin.com/pulse/talent-system-behind-hyper-growth-why-entry-level-pools-dan-leitner-algrc/",
    image: "https://media.licdn.com/dms/image/v2/D5612AQGWYSSnqjD04Q/article-cover_image-shrink_720_1280/B56Zza7McgH8AI-/0/1773199482538?e=2147483647&v=beta&t=EdThB6PbZGoiEiUeYzUNigz3957oIopIj_ofVkBKV7k"
  },
  {
    title: "Why Most SDR Models Fail Financially",
    description: "Measure SDR investment by revenue impact, not activity volume.",
    tag: "Economics",
    link: "https://www.linkedin.com/pulse/sdr-economics-what-most-business-plans-get-completely-dan-leitner-haame/",
    image: "https://media.licdn.com/dms/image/v2/D4D12AQGGRGuMGAL3mA/article-cover_image-shrink_720_1280/B4DZxTkMADHkAI-/0/1770928527443?e=2147483647&v=beta&t=-2FnyaulHj-TRfafbL3WELljIJJ6RvXNlkv14hi9tLM"
  },
  {
    title: "Why GTM Transformations Break",
    description: "Fix system gaps that kill pipeline before tactics can help.",
    tag: "GTM",
    link: "https://www.linkedin.com/pulse/why-gtm-transformations-fail-what-high-performing-do-dan-leitner-pukie/",
    image: "https://media.licdn.com/dms/image/v2/D4E12AQFERGpcDp92eQ/article-cover_image-shrink_720_1280/B4EZwqUNXlGcAI-/0/1770236471162?e=2147483647&v=beta&t=lfcy6r_wTvttX1FS-k9lTRuXYLSoZijh-tkWi-lOyno"
  },
  {
    title: "How to Design an AI-Powered SDR System That Produces Pipeline",
    description: "Build SDR systems that scale outreach without sacrificing quality.",
    tag: "AI + SDR",
    link: "https://www.linkedin.com/pulse/how-design-ai-powered-sdr-agent-team-where-most-teams-dan-leitner-q9foc/",
    image: "https://media.licdn.com/dms/image/v2/D5612AQHoqD9j6OPvfQ/article-cover_image-shrink_720_1280/B56ZuaiYovKEAI-/0/1767824267682?e=2147483647&v=beta&t=ruFDrcPhUkjhXWmtJ0Syx8_TeZX8JTAYko63S-061Lw"
  },
  {
    title: "AI-Powered SDR Agents: The 2026 Reality",
    description: "Treat AI as infrastructure, not a shortcut.",
    tag: "AI",
    link: "https://www.linkedin.com/pulse/ai-powered-sdr-agents-2026-reality-dan-leitner-pkkzc/",
    image: "https://media.licdn.com/dms/image/v2/D5612AQHnz-8vI3ac9A/article-cover_image-shrink_720_1280/B56Zt6_sPQHgAI-/0/1767295079925?e=2147483647&v=beta&t=g9YKp6giOk1mEUA-Ui2LciINoh2zCU_vGqur8xY7YF8"
  }
];

const InsightsPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] overflow-x-hidden">
      <SEO 
        title="Insights | GTM Strategy & Leadership Thinking"
        description="Articles on revenue systems, SDR economics, talent development, and GTM execution. Practical thinking for Series B & C startup leaders."
        path="/insights"
        image="insights"
      />
      <Navigation />
      
      {/* Hero */}
      <section className="pt-24 sm:pt-32 pb-10 sm:pb-16 lg:pb-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white tracking-tight leading-tight mb-4 sm:mb-6">
            LRS Insights
          </h1>
          <p className="text-base sm:text-lg text-zinc-300 max-w-2xl mx-auto">
            Thinking on revenue systems, SDR economics, talent development, and GTM execution.
          </p>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-8 sm:py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {allArticles.map((article) => (
              <a 
                key={article.title}
                href={article.link}
                target="_blank"
                rel="noopener noreferrer"
                className="group block bg-[#1C1C1C] rounded-xl overflow-hidden border border-white/5 hover:border-[#D4AF37]/30 transition-all hover:-translate-y-1"
                data-testid={`insight-card-${article.title.replace(/\s+/g, '-').toLowerCase()}`}
              >
                {/* Image */}
                <div className="aspect-[16/9] overflow-hidden relative">
                  <img 
                    src={article.image} 
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  {article.isNew && (
                    <div className="absolute top-2 sm:top-3 right-2 sm:right-3 px-2 sm:px-3 py-0.5 sm:py-1 bg-[#D4AF37] rounded-full">
                      <span className="text-[10px] sm:text-xs font-bold text-[#0A0A0A]">NEW</span>
                    </div>
                  )}
                </div>
                
                {/* Content */}
                <div className="p-4 sm:p-6">
                  <div className="flex items-center justify-between mb-3 sm:mb-4">
                    <span className="px-2 sm:px-3 py-0.5 sm:py-1 bg-[#D4AF37]/10 rounded text-[10px] sm:text-xs font-medium text-[#D4AF37]">
                      {article.tag}
                    </span>
                    <ExternalLink className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-zinc-400 group-hover:text-[#D4AF37] transition-colors" />
                  </div>
                  <h3 className="text-base sm:text-lg font-semibold text-white mb-2 sm:mb-3 group-hover:text-[#D4AF37] transition-colors leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs sm:text-sm text-zinc-300">
                    {article.description}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 lg:py-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center">
          <p className="text-zinc-300 mb-6">
            Want to discuss how these ideas apply to your team?
          </p>
          <Link
            to="/#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#D4AF37] text-[#0A0A0A] rounded-lg font-semibold hover:bg-[#E8C547] transition-all"
          >
            Start a Conversation
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default InsightsPage;
